import React from 'react'
import PropTypes from 'prop-types'
import {
    Flex,
    useMultiStyleConfig,
    Button,
    Link as ChakraLink,
} from '@salesforce/retail-react-app/app/components/shared/ui'

const DrawerHeaderLinkItem = ({headerLink}) => {
    const styles = useMultiStyleConfig('BraunMenu', {})

    const isAbsolute = headerLink?.is_external_url || false
    const url = headerLink?.link?.href
    const title = headerLink?.link?.title

    const drawerItem = styles?.drawerItem || {}
    const headerLinksStyles = styles?.headerLinksStyles || {}

    return (
        <Flex w="100%">
            {isAbsolute ? (
                <ChakraLink
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    textDecoration="none"
                    _hover={{textDecoration: 'none'}}
                    {...drawerItem.itemText}
                >
                    {title}
                </ChakraLink>
            ) : (
                <Button as="a" href={url} {...headerLinksStyles?.headerLinkItem}>
                    {title}
                </Button>
            )}
        </Flex>
    )
}

DrawerHeaderLinkItem.propTypes = {
    headerLink: PropTypes.object,
    categoryData: PropTypes.object,
}

export default DrawerHeaderLinkItem
